import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

@Component({
  selector: 'page-scancode',
  templateUrl: 'scancode.html'
})

export class ScancodePage {

  constructor() { }


}



// WEBPACK FOOTER //
// ./src/pages/scancode/scancode.ts